export enum GeneralReportType {
  NSearch = 0,
  Student = 1,
}
